import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    MatCheckboxChange,
    MatCheckboxModule,
} from '@angular/material/checkbox';
import { IDatiqCellSelect, IDatiqCellSelectChange, emptyDatiqCellSelect } from './models';

@Component({
    selector: 'datiq-cell-select',
    standalone: true,
    imports: [CommonModule, MatCheckboxModule],
    templateUrl: './datiq-cell-select.component.html',
    styleUrls: ['./datiq-cell-select.component.scss'],
})
export class DatiqCellSelectComponent implements OnInit {
    @Input()
    settings: IDatiqCellSelect;

    @Output()
    changed: EventEmitter<IDatiqCellSelectChange> =
        new EventEmitter<IDatiqCellSelectChange>();

    ngOnInit(): void {
        this.settings = this.settings ?? { ...emptyDatiqCellSelect };
    }

    checkboxChanged(event: MatCheckboxChange): void {
        this.settings = {
            ...this.settings,
            selected: event.checked,
        };

        this.changed.emit({
            checked: event.checked,
            data: this.settings.data,
        });
    }
}
